import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import {
  allLinks,
  removeQuoteLink,
} from 'components/consumer/CustomerDashboardPageTemplate/components/CustomerDashboardLinks/CustomerDashboardLinksUI';

const stripTrailingSlash = path =>
  path.endsWith('/') ? path.slice(0, -1) : path;

const CustomerDashboardNavLinksUI = ({
  currentPath,
  items = [],
  showQuoteLink = false,
}) => (
  <ul className="flex flex-col list-none ml-0">
    {items
      .filter(showQuoteLink ? allLinks : removeQuoteLink)
      .map(({ label, path }) => {
        const isSelected = currentPath.startsWith(stripTrailingSlash(path));
        return (
          <li>
            <Link
              aria-current={isSelected ? 'page' : undefined}
              className={classNames(
                'text-base !text-gray flex px-11 py-3 no-underline hover:[border-top:1px_solid_#f1f1f1] hover:[border-bottom:1px_solid_#f1f1f1] hover:[border-left:8px_solid_#107c8c] hover:!no-underline',
                {
                  'font-normal [border-top:1px_solid_transparent] [border-bottom:1px_solid_transparent] [border-left:8px_solid_transparent]': !isSelected,
                  'font-bold [border-top:1px_solid_#f1f1f1] [border-bottom:1px_solid_#f1f1f1] [border-left:8px_solid_#107c8c] !no-underline bg-white': isSelected,
                }
              )}
              to={path}
            >
              {label}
            </Link>
          </li>
        );
      })}
  </ul>
);

CustomerDashboardNavLinksUI.propTypes = {
  currentPath: PropTypes.string,
  items: PropTypes.shape({
    label: PropTypes.string,
    path: PropTypes.string,
  }),
  showQuoteLink: PropTypes.bool,
};

export default CustomerDashboardNavLinksUI;
